import i18n from "../i18n";

export const initialState = {
    value: (localStorage.getItem('userLang') && localStorage.getItem('userLang') !== undefined && localStorage.getItem('userLang') !== '') ? (localStorage.getItem('userLang')) : (i18n.language || 'en'),
    goUrlLocale: (localStorage.getItem('userLang') && localStorage.getItem('userLang') !== undefined && localStorage.getItem('userLang') !== '') ? localStorage.getItem('userLang') : (i18n.language || 'en'),
    availableLocales: [],
    adobeGlobalNavLocale:(localStorage.getItem('globalLocale') && localStorage.getItem('globalLocale') !== undefined && localStorage.getItem('globalLocale') !== '') ? localStorage.getItem('globalLocale') : 'en_US',
    localeStatus: false
};


const LocaleReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_LOCALE':{
            return  {
                ...state,
                value:action.value
            }
        }
        case 'SET_AVAILABLE_LOCALE':{
            return  {
                ...state,
                availableLocales:action.value
            }
        }
        case 'SET_NAV_LOCALE':{
            return  {
                ...state,
                adobeGlobalNavLocale:action.value
            }
        }
        case 'SET_GO_URL_LOCALE':{
            return  {
                ...state,
                goUrlLocale:action.value
            }
        }
        case 'SET_LOCALE_STATUS':{
            return  {
                ...state,
                localeStatus:action.value
            }
        }
        default:
            return state;
    }

};

export default LocaleReducer;
